import AugmentImage from "common/src/tft-static/AugmentImage";
import { Desc } from "common/src/components/RitoDescription2";
import { augments as augmentsT } from "common/src/bindings/Translation2";
import AdLayout from "../app-core/AdLayout";

const encodeAugmentId = (augId: string) =>
  augId.replace(/TFT(.*?)_Augment_(.+)/, "$1$2");

type Legend = {
  id: string;
  name: string;
  desc: string;
  early: Array<string>;
  mid: Array<string>;
  late: Array<string>;
};

const AugsGroup = ({
  label,
  augments,
}: {
  label: string;
  augments: Array<string>;
}) => {
  return (
    <>
      <div className="flex flex-col font-montserrat text-lg font-medium text-center leading-none">
        <div>{label}</div>
      </div>
      {augments.map((v) => (
        <div className="flex gap-[6px] items-start pb-2">
          <AugmentImage key={v} augId={encodeAugmentId(v)} size={40} />
          <div>
            <div className="font-medium font-montserrat text-[15px] pb-1">
              {augmentsT(encodeAugmentId(v))}
            </div>
            <Desc desc={augmentsT(`${encodeAugmentId(v)}_desc`)} />
          </div>
        </div>
      ))}
    </>
  );
};

const Legend = ({ legend }: { legend: Legend }) => {
  const [name, title] = legend.name.split(/:\s?/);
  return (
    <div className="flex items-start gap-6">
      <div className="relative w-[192px] h-[384px] flex-shrink-0 self-center">
        <img
          src={`https://ap.tft.tools/img/sup9/legends_ver/${legend.id}.png`}
        />
        <div className="w-full flex flex-col items-center text-center absolute left-0 top-[264px] px-2">
          <div className="text-xl leading-tight font-montserrat font-medium">
            {name}
          </div>
          <div className="text-lg pt-1 leading-tight font-montserrat font-medium">
            {title}
          </div>
          <div className="leading-tight pt-2">{legend.desc}</div>
        </div>
      </div>
      {legend.id === "Poro" ? null : (
        <div className="py-4 pr-4 grid grid-cols-1 sm:grid-cols-3 grid-flow-col grid-rows-[repeat(12,auto)] sm:grid-rows-[repeat(4,auto)] gap-8 gap-y-6">
          <AugsGroup label="Stage 2-1" augments={legend.early} />
          <AugsGroup label="Stage 3-2" augments={legend.mid} />
          <AugsGroup label="Stage 4-2" augments={legend.late} />
        </div>
      )}
    </div>
  );
};

export default function LegendsPage({ legends }: { legends: Array<Legend> }) {
  legends.sort((a, b) => {
    if (a.id === "Poro") {
      return 1;
    } else if (b.id === "Poro") {
      return -1;
    } else {
      return a.name.localeCompare(b.name);
    }
  });
  return (
    <AdLayout>
      <div className="flex flex-col pb-4 text-[12px] lg:text-[13px] bg-bg rounded md:w-[900px] pb-4 mt-8">
        {legends.map((legend) => (
          <Legend key={legend.id} legend={legend} />
        ))}
      </div>
    </AdLayout>
  );
}
